module.exports = __webpack_public_path__ + "img/lunar-epic-2.8b59fc01.jpg";